import { useLicenseInfo } from '../../../../redux/slices/license/hooks/hooks';
import { useOnboardingState } from '../../../onboarding/useOnboardingState';

/**
 * True for a workspace that never had a trial: the signup trial was refused because the person had
 * one before (`onboarding.state.trialSkipped`), or the licence holds no trial item. Such a person
 * did not "go" to Free, so the upsell copy must not say "now" (onboarding review 2026-10-19,
 * finding 1). An API from before `trialSkipped` sends nothing: the licence fact still decides.
 */
export function useNeverHadTrial(): boolean {
  const licenseInfo = useLicenseInfo();
  const { state } = useOnboardingState();
  const trialSkipped = state?.trialSkipped ?? null;
  return trialSkipped === 'alreadyUsed' || licenseInfo.trialStatus === 'none';
}
